import styled from 'styled-components';
import { Row } from '@met/react-components';

const StyledDetailsRow = styled(Row)`
  display: ${props => props.visible ? 'block' : 'none'};
`;

export {
  StyledDetailsRow
};